import styled from 'styled-components';

import logoSrc from '../../assets/logo-strategies@2x.png';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 262px;
  height: 263px;
  background-color: #fff;
  border-radius: 25px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 133px;
  padding: 22px;
  color: #fff;
  background-color: #e74391;
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 113px;
  left: 50%;
  width: 48px;
  height: 48px;
  background-image: url(${logoSrc});
  background-repeat: no-repeat;
  background-size: auto 48px;
  overflow: hidden;
  transform: translateX(-50%);
`;

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
  text-align: center;
`;
